import styled from 'styled-components';

const ContentStyles = styled.div`
    position: relative;
    max-width: 1000px;
    margin: 0 auto;
`;

export default ContentStyles;